export enum Touchpoints {
  blix = 'BLIX',
  meta = 'META',
  ooh = 'OOH',
  youtube = 'YOUTUBE',
  tv = 'TV',
  snapchat = 'SNAPCHAT',
  pinterest = 'PINTEREST',
  programmaticDisplay = 'PROGRAMMATIC DISPLAY',
  tiktok = 'TIKTOK',
}
